const REFRESH_TOKEN_KEY = 'gof_refresh_token';
const TOKEN_EXPIRY_KEY = 'gof_token_expiry';

let accessToken = null;

export function getAccessToken() {
  return accessToken;
}

export function setAccessToken(token) {
  accessToken = token;
}

export function getRefreshToken() {
  return localStorage.getItem(REFRESH_TOKEN_KEY);
}

export function setRefreshToken(token) {
  localStorage.setItem(REFRESH_TOKEN_KEY, token);
}

export function getTokenExpiry() {
  const value = localStorage.getItem(TOKEN_EXPIRY_KEY);
  if (value === null) {
    return null;
  }
  const parsed = Number(value);
  return Number.isNaN(parsed) ? null : parsed;
}

export function setTokenExpiry(expiry) {
  localStorage.setItem(TOKEN_EXPIRY_KEY, String(expiry));
}

export function setTokens(accessTokenValue, refreshToken, expiresIn) {
  setAccessToken(accessTokenValue);
  setRefreshToken(refreshToken);
  setTokenExpiry(Date.now() + expiresIn * 1000);
}

export function clearAllTokens() {
  accessToken = null;
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(TOKEN_EXPIRY_KEY);
}

export function isTokenExpiringSoon() {
  const expiry = getTokenExpiry();
  if (expiry === null) {
    return true;
  }
  return expiry < Date.now() + 60000;
}
